"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreferenceSubHeader = exports.Heading = exports.MarkAllAsRead = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-1fq2x9d-0"
})(function (_ref) {
  var _theme$brand$colors$p, _theme$brand, _theme$brand$colors, _theme$brand$colors$p2, _theme$brand2, _theme$brand2$colors, _theme$brand$inapp$bo, _theme$brand3, _theme$brand3$inapp, _theme$brand$inapp$bo2, _theme$brand4, _theme$brand4$inapp;

  var theme = _ref.theme,
      view = _ref.view;
  return (0, _deepExtend["default"])({
    padding: "18px",
    paddingLeft: "38px",
    userSelect: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 24,
    fontWeight: 700,
    height: "65px",
    color: "rgb(36, 50, 75)",
    backgroundColor: "white",
    "svg:hover": {
      background: "#f7f6f9",
      "path, circle": {
        stroke: (_theme$brand$colors$p = theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary) !== null && _theme$brand$colors$p !== void 0 ? _theme$brand$colors$p : "#9121c2"
      }
    },
    "svg path, svg circle": {
      stroke: view === "preferences" ? (_theme$brand$colors$p2 = theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary) !== null && _theme$brand$colors$p2 !== void 0 ? _theme$brand$colors$p2 : "#9121c2" : undefined
    },
    ".actions": {
      display: "flex",
      alignItems: "center"
    },
    borderTopLeftRadius: (_theme$brand$inapp$bo = theme === null || theme === void 0 ? void 0 : (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$inapp = _theme$brand3.inapp) === null || _theme$brand3$inapp === void 0 ? void 0 : _theme$brand3$inapp.borderRadius) !== null && _theme$brand$inapp$bo !== void 0 ? _theme$brand$inapp$bo : "24px",
    borderTopRightRadius: (_theme$brand$inapp$bo2 = theme === null || theme === void 0 ? void 0 : (_theme$brand4 = theme.brand) === null || _theme$brand4 === void 0 ? void 0 : (_theme$brand4$inapp = _theme$brand4.inapp) === null || _theme$brand4$inapp === void 0 ? void 0 : _theme$brand4$inapp.borderRadius) !== null && _theme$brand$inapp$bo2 !== void 0 ? _theme$brand$inapp$bo2 : "24px"
  }, theme === null || theme === void 0 ? void 0 : theme.header);
});

exports.Container = Container;

var MarkAllAsRead = _styledComponents["default"].button.withConfig({
  displayName: "styled__MarkAllAsRead",
  componentId: "sc-1fq2x9d-1"
})(function () {
  return {
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0em",
    color: "#73819B",
    border: "1px solid #E4DFF0",
    background: "white",
    padding: "4px 18px",
    borderRadius: "4px",
    "&:hover": {
      background: "#f7f6f9"
    }
  };
});

exports.MarkAllAsRead = MarkAllAsRead;

var Heading = _styledComponents["default"].div.withConfig({
  displayName: "styled__Heading",
  componentId: "sc-1fq2x9d-2"
})(function (_ref2) {
  var _theme$brand$colors$p3, _theme$brand5, _theme$brand5$colors;

  var theme = _ref2.theme,
      flexDirection = _ref2.flexDirection,
      alignItems = _ref2.alignItems;
  return {
    display: "flex",
    flexDirection: flexDirection,
    alignItems: alignItems,
    ".message-count": {
      fontSize: 18,
      marginLeft: 14,
      background: (_theme$brand$colors$p3 = (_theme$brand5 = theme.brand) === null || _theme$brand5 === void 0 ? void 0 : (_theme$brand5$colors = _theme$brand5.colors) === null || _theme$brand5$colors === void 0 ? void 0 : _theme$brand5$colors.primary) !== null && _theme$brand$colors$p3 !== void 0 ? _theme$brand$colors$p3 : "#9121c2",
      color: "white",
      borderRadius: "17px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 27,
      padding: "0 6px",
      minWidth: 27
    }
  };
});

exports.Heading = Heading;

var PreferenceSubHeader = _styledComponents["default"].a.withConfig({
  displayName: "styled__PreferenceSubHeader",
  componentId: "sc-1fq2x9d-3"
})(function (_ref3) {
  var _theme$brand$colors$p4, _theme$brand6, _theme$brand6$colors;

  var theme = _ref3.theme;
  return {
    cursor: "pointer",
    color: (_theme$brand$colors$p4 = theme === null || theme === void 0 ? void 0 : (_theme$brand6 = theme.brand) === null || _theme$brand6 === void 0 ? void 0 : (_theme$brand6$colors = _theme$brand6.colors) === null || _theme$brand6$colors === void 0 ? void 0 : _theme$brand6$colors.primary) !== null && _theme$brand$colors$p4 !== void 0 ? _theme$brand$colors$p4 : "#9121c2",
    fontSize: "12px"
  };
});

exports.PreferenceSubHeader = PreferenceSubHeader;